import React from "react";
import {
  FaFacebook,
  FaGithub,
  FaTiktok,
  FaYoutube,
  FaHeart,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="ios-glass backdrop-blur-ios border-t border-ios-border mt-16 safe-area-bottom">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Logo and Copyright */}
          <div className="flex items-center space-x-3">
            <div className="w-auto px-2 h-10 bg-gradient-to-br from-ios-primary to-ios-secondary rounded-ios-lg flex items-center justify-center shadow-ios">
              <span className="text-white font-bold text-lg">MovH</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
              <span className="text-xl font-bold text-gradient-ios">
                MovieHub
              </span>
            </div>
          </div>

          {/* Mobile Copyright */}
          <p className="text-ios-textSecondary text-sm lg:hidden">
            Made with <FaHeart className="inline text-ios-error" /> by akhel
          </p>

          {/* Social Links */}
          <div className="flex items-center space-x-3">
            <button
              className="ios-button text-ios-textSecondary hover:text-ios-text hover:scale-110 transition-all duration-300"
              aria-label="Facebook"
            >
              <FaFacebook className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
            <button
              className="ios-button text-ios-textSecondary hover:text-ios-text hover:scale-110 transition-all duration-300"
              aria-label="GitHub"
            >
              <FaGithub className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
            <button
              className="ios-button text-ios-textSecondary hover:text-ios-text hover:scale-110 transition-all duration-300"
              aria-label="TikTok"
            >
              <FaTiktok className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
            <button
              className="ios-button text-ios-textSecondary hover:text-ios-text hover:scale-110 transition-all duration-300"
              aria-label="YouTube"
            >
              <FaYoutube className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>
        </div>

        {/* Desktop Copyright */}
        <div className="hidden lg:flex items-center justify-center mt-6 pt-6 border-t border-ios-borderSecondary">
          <p className="text-ios-textSecondary text-sm">
            Made with ❤️ by akhel • ©
            2025 CineSearch.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
